import { useCallback } from 'react';
import { useNavigationContextV3 } from './NavigationContextV3/NavigationContextV3.js';
import { findSelectedItemsByUrl } from './navigationV3.logic.js';
export function useNavigation() {
    const context = useNavigationContextV3();
    const activeNavUrl = context.selectedSubNavUrl ?? context.selectedNavUrl;
    const setActiveNavUrl = useCallback((url) => {
        const { navConfig, setState } = context;
        const result = findSelectedItemsByUrl([...(navConfig?.topNav || []), ...(navConfig?.bottomNav || [])], url);
        setState((prev) => ({ ...prev, ...result }));
    }, [context.navConfig]);
    return [activeNavUrl, setActiveNavUrl];
}
//# sourceMappingURL=useNavigation.js.map